/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-types */
import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PDFDocumentProxy } from 'ng2-pdf-viewer';
@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: FileUploadComponent,
      multi: true,
    },
  ],
  styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent implements ControlValueAccessor {
  onChange!: Function;
  public file: File | null = null;
  public filePreview: string | ArrayBuffer | undefined | null = null;
  @Input() submit: string = "";
  @Output() archivoBase64: EventEmitter<string> = new EventEmitter<string>();

  data:any = {
    tipo : 'add'
  }
  title = 'pdf-to-image';
  public pdfSrc = "";
  imageSrc: string | ArrayBuffer | null = null;
  public totalPages: number = 0;
  public currentpage: number = 0;
  public isCropImage: boolean = false;
  public isPdfUploaded :boolean = false;
  public isImageUploaded = false;

  public base64Data: string = "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"

  @HostListener('change', ['$event.target.files']) emitFiles(event: FileList) {
    const file = event && event.item(0);
    this.onChange(file);
    this.file = file;
  }

  constructor(private host: ElementRef<HTMLInputElement>) { }

  onFileSelected(event: any): void {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      this.file = selectedFile;
      this.readFile(selectedFile);
    }
  }

  readFile(file: File): void {
    const reader = new FileReader();
    reader.onload = (e:any) => {
      this.filePreview = e.target?.result as string;
      const base64String = btoa(e.target?.result);
      this.archivoBase64.emit(base64String)

    };
    reader.readAsDataURL(file);
  }

  uploadFile(event: any) {
    this.onFileSelected(event);
    // this.readFile(event);
    const file = event.target.files[0];
    if (file.type === 'application/pdf') {
      this.isPdfUploaded = true;
      this.isImageUploaded = false;
      this.displayPdf(file);
    } else if (file.type.startsWith('image/')) {
      this.isPdfUploaded = false;
      this.isImageUploaded = true;
      this.displayImage(file);
    } else {
      // alert('Please upload a PDF or image file');
    }

    this.convertirPdf()
  }

  convertirPdf() {
    // Decodificar la cadena Base64
    const binaryString = window.atob(this.base64Data);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    // Crear un Blob
    const blob = new Blob([bytes], { type: 'application/pdf' });

    // Crear URL de objeto
    const url = window.URL.createObjectURL(blob);

    // Crear enlace <a> y configurarlo
    const link = document.createElement('a');
    link.href = url;
    link.download = 'Solicitud_audiencia.pdf';
  }

  displayPdf(file: File) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.pdfSrc = e.target.result;
    };
    reader.readAsArrayBuffer(file);
  }

  displayImage(file: File) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.imageSrc = e.target.result;
    };
    reader.readAsDataURL(file);
  }

    // after pdf uploaded
    afterLoadComplete(pdf: PDFDocumentProxy) {
      this.totalPages = pdf.numPages;
    }

  writeValue(value: null) {
    // clear file input
    this.host.nativeElement.value = '';
    this.file = null;
  }

  registerOnChange(fn: Function) {
    this.onChange = fn;
  }

  registerOnTouched(fn: Function) {
    // add code here
  }

}
